import PropTypes from 'prop-types';
import Breadcrumb from './Breadcrumb';
import './PageHeader.css';

export default function PageHeader({
    title,
    subtitle,
    breadcrumbs,
    actions,
    className = ''
}) {
    return (
        <div className={`page-header ${className}`}>
            {breadcrumbs && <Breadcrumb items={breadcrumbs} />}
            <div className="page-header-content">
                <div className="page-header-text">
                    <h1 className="page-title">{title}</h1>
                    {subtitle && <p className="page-subtitle">{subtitle}</p>}
                </div>
                {actions && <div className="page-header-actions">{actions}</div>}
            </div>
        </div>
    );
}

PageHeader.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    breadcrumbs: PropTypes.array,
    actions: PropTypes.node,
    className: PropTypes.string
};
